"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SinglePendingAsync = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var Utilities_1 = require("./Utilities");
var SinglePendingAsync = /** @class */ (function () {
    function SinglePendingAsync() {
        this._currentPromise = null;
        this._pendingExecutor = null;
    }
    SinglePendingAsync.prototype.execute = function (executor, onSkipped) {
        var _this = this;
        var _a, _b;
        if (this._currentPromise) {
            (_b = (_a = this._pendingExecutor) === null || _a === void 0 ? void 0 : _a.onSkipped) === null || _b === void 0 ? void 0 : _b.call(_a);
            this._pendingExecutor = { executor: executor, onSkipped: onSkipped };
            return (0, Utilities_1.fin)(this._currentPromise, function (result) {
                if (_this._pendingExecutor) {
                    var pendingExecutor = _this._pendingExecutor;
                    _this._pendingExecutor = null;
                    return _this.execute(pendingExecutor.executor);
                }
                return result;
            });
        }
        this._currentPromise = (0, Utilities_1.fin)(executor(), function (result) {
            _this._currentPromise = null;
            return result;
        });
        return this._currentPromise;
    };
    SinglePendingAsync.prototype.dispose = function () {
        var _a;
        if ((_a = this._pendingExecutor) === null || _a === void 0 ? void 0 : _a.onSkipped) {
            this._pendingExecutor.onSkipped();
        }
        this._pendingExecutor = null;
    };
    return SinglePendingAsync;
}());
exports.SinglePendingAsync = SinglePendingAsync;
//# sourceMappingURL=SinglePendingAsync.js.map